import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import moment from 'moment';
import AssignmentBadge from './AssignmentBadge';
import styles from './SleepScreenCard.module.css';

// Cloudinary first-frame poster: insert so_0 transform + swap extension to jpg.
// `https://.../video/upload/v.../file.webm` → `https://.../video/upload/so_0/v.../file.jpg`
const videoUrlToPosterUrl = (videoUrl) => {
  if (!videoUrl) return null;
  return videoUrl
    .replace('/upload/', '/upload/so_0/')
    .replace(/\.(webm|mp4|mov)(\?.*)?$/i, '.jpg$2');
};

const SleepScreenCard = ({ entry, assignmentCount }) => {
  const poster = videoUrlToPosterUrl(entry.videoUrl);
  const timestamp = entry.createdAt ? moment(entry.createdAt).fromNow() : null;

  return (
    <div className={styles.card}>
      <div className={styles.thumbWrapper}>
        {poster ? (
          <img
            className={styles.thumb}
            src={poster}
            alt={entry.displayName || 'Sleep screen'}
            loading="lazy"
          />
        ) : (
          <div className={styles.thumbPlaceholder}>VIDEO</div>
        )}
      </div>
      <div className={styles.body}>
        <div className={styles.displayName}>{entry.displayName || '—'}</div>
        <div className={styles.id}>{entry.sleepScreenId}</div>
        {assignmentCount !== null && assignmentCount !== undefined && (
          <div className={styles.badgeRow}>
            <AssignmentBadge count={assignmentCount} />
          </div>
        )}
        {timestamp && <div className={styles.timestamp}>{timestamp}</div>}
      </div>
      <div className={styles.actions}>
        <Link
          className={styles.actionButton}
          to={`/sleep-screens/${encodeURIComponent(entry.sleepScreenId)}`}
        >
          view
        </Link>
        <Link
          className={styles.actionButton}
          to={`/sleep-screens/${encodeURIComponent(entry.sleepScreenId)}/edit`}
        >
          edit
        </Link>
      </div>
    </div>
  );
};

SleepScreenCard.propTypes = {
  entry: PropTypes.shape({
    sleepScreenId: PropTypes.string.isRequired,
    videoUrl: PropTypes.string,
    displayName: PropTypes.string,
    createdAt: PropTypes.string,
    updatedBy: PropTypes.string,
  }).isRequired,
  assignmentCount: PropTypes.number,
};

SleepScreenCard.defaultProps = {
  assignmentCount: null,
};

export default SleepScreenCard;
